import { formatDate } from "@/utils/date-conversion";

export const downloadCSV = <Row extends Record<string, unknown>>(
  rows: Row[],
  filenameBase: string,
  headers: (keyof Row)[],
  prettyHeaders: string[],
  exactFilename?: string,
) => {
  if (rows.length === 0) return;

  const filename = exactFilename ?? `${filenameBase}_${formatDate(new Date())}.csv`;

  const csvContent = [
    prettyHeaders.join(","),
    ...rows.map((row) => headers.map((key) => `"${formatRow(row[key])}"`).join(",")),
  ].join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href); // Because AI told me to
};

const formatRow = (val: unknown) => {
  if (val == null) return "";
  if (Array.isArray(val)) return val.join("; ").replace(/"/g, '""');
  return String(val).replace(/"/g, '""');
};
